
/**
 * All images are now mapped to a local 'assets/images' directory.
 * Make sure to download your preferred images and save them in:
 * your-project-root/assets/images/
 */
export const IMAGES = {
  // Brand Identity
  LOGO: "/images/logo02.png",
  // Hero & Backgrounds
  HOME_HERO: "/images/bundelibanner.jpg",
  BULK_HERO_PATTERN: "/images/bulk-pattern.jpg",
  
  // Section Images
  BRAND_STORY: "/images/tea making.jpg",
  DISTRIBUTOR_PROMO: "/images/distributionship.jpeg",
  BULK_PROMO: "/images/bulk order.jpeg",
  
  // About Page
  ABOUT_GARDEN: "/images/tra garden.jpg",
  ABOUT_PROCESSING: "/images/plucking.jpg",
  OWNER_IMAGE: "/images/owner.jpeg",
  
  // Product Categories
  PRODUCT_PREMIUM_CTC: "/images/ctc.jpeg",
  PRODUCT_CTC_STRONG: "/images/ctc.jpeg",
  PRODUCT_CTC_GOLD: "/images/ctc.jpeg",
  PRODUCT_FAMILY: "/images/alltype.jpeg",
  PRODUCT_DHABA: "/images/alltype.jpeg",
  PRODUCT_ELAICHI: "/images/teas.jpeg",
  PRODUCT_ADRAK_ELAICHI: "/images/teas.jpeg",
  PRODUCT_MASALA_CHAI: "/images/teas.jpeg",
  PRODUCT_GREEN_TEA: "/images/greenandherbal.jpeg",
  PRODUCT_BLUE_TEA: "/images/blue.jpeg",
  PRODUCT_HERBAL: "/images/greenandherbal.jpeg",
  
  // Legacy / Misc
  PRODUCT_CATERING_BULK: "/images/product-bulk-catering.jpg",
  PRODUCT_GOLD_DUST: "/images/product-gold-dust.jpg",
  PRODUCT_OFFICE_REFRESH: "/images/product-office-refresh.jpg",
  
  // Features
  BULK_QUALITY_FEATURE: "/assets/images/bulk-quality.jpg",
};
